import {
  ORDER_IRI,
  CHANNEL_IRI,
  CHANNEL_OFFERS_IRI,
  PRODUCT_VARIANTS_IRI,
  SERVICE_IRI,
  USER_IRI,
  CAMPAIGN_IRI,
  SELFCONSUMPTION_CUPS_TYPE_IRI,
  SELFCONSUMPTION_CUPS_SUBSECTION_TYPE_IRI,
} from './constants'
import { COMPANY_CODES, DOMESTIC, ELECTRICITY, ENERGY_USES, GAS } from 'utils/constants'
import { formatNumber } from 'utils/commons'
import {
  SELFCONSUMPTION_DISABLED,
  COLLECTIVE,
  INDIVIDUAL,
  DEFAULT_TYPE_SUBSECTION,
  WITOUT_SELFCONSUMPTION,
  WITOUT_SELFCONSUMPTION_ID,
} from 'services/selfconsumption/constants'

const changeSupplyOwnershipFromDraft = (energyType, draft) => {
  if (!draft) return false
  const { orderlines } = draft
  let orderLine
  if (energyType === ELECTRICITY.toLowerCase()) {
    orderLine = orderlines?.find((orderline) => orderline?.technicalInfoElectricity !== null)
  } else {
    orderLine = orderlines?.find((orderline) => orderline?.technicalInfoGas !== null)
  }

  return orderLine?.changeSupplyOwnership
}

const changeSupplyOwnershipFromDuplicateDraft = (energyType, draft) => {
  if (!draft) return false
  const orderlines = draft?.ownerStep?.supplyOwnerShip
  let orderLine
  if (energyType === ELECTRICITY.toLowerCase()) {
    orderLine = orderlines?.find((orderline) => orderline?.energyType !== null)
  } else {
    orderLine = orderlines?.find((orderline) => orderline?.energyType !== null)
  }

  return orderLine?.changeSupplyOwnerShip
}
const getFlatDraftPrice = (type, flateRate) => {
  if (flateRate) {
    const flatRatePrice = flateRate.filter((item) => item?.pricingCalculation?.energyType === type)
    const flatRatePriceAmount = flatRatePrice[0]?.pricingCalculation
    return flatRatePriceAmount
  }
}

export const getOrders = (
  products,
  order,
  toppings,
  customer,
  selectedChannel,
  campaigns,
  userId,
  guidelineDate,
  isPyme,
  isPhoneChannel,
  selfconsumptionTypes,
  orderDraft,
  onlineChannelDraft,
  duplicateOrdeDraft,
  byCups
) => {
  let productOrderLines = []
  const supplyPoints = customer.supplyPoints
  const supplyOnlinePoints = onlineChannelDraft?.supplyStep
  const selectedProduct = products.selected
  const isDualTariff =
    supplyPoints?.some(({ energyType }) => energyType === ELECTRICITY) &&
    supplyPoints?.some(({ energyType }) => energyType === GAS)
  let orderIdOnlineChannel
  if (supplyOnlinePoints) {
    if (isDualTariff) {
      orderIdOnlineChannel = supplyOnlinePoints?.electricity?.supplies[0]?.orderId
    } else {
      if (selectedProduct.energyType === ELECTRICITY) {
        orderIdOnlineChannel = supplyOnlinePoints?.electricity?.supplies[0]?.orderId
      } else if (selectedProduct.energyType === GAS) {
        orderIdOnlineChannel = supplyOnlinePoints?.gas?.supplies[0]?.orderId
      }
    }
  }

  const flatRateFromDraft = orderDraft?.orderlines

  const productsVariants =
    products?.selectedVariants || selectedProduct?.variants || getProductVariantDual(isDualTariff, selectedProduct)
  const VCN = {
    electricity:
      customer.supplyPoints &&
      customer.supplyPoints.length &&
      customer.supplyPoints.find((sp) => sp?.energyType === ELECTRICITY)?.validationClientNode,
    gas:
      customer.supplyPoints &&
      customer.supplyPoints.length &&
      customer.supplyPoints.find((sp) => sp?.energyType === GAS)?.validationClientNode,
  }

  const changeSupplyOwnership = {
    electricity:
      VCN.electricity === null || VCN.electricity === undefined
        ? customer.changeSupplyOwnership['changeSupplyOwnership-electricity']
        : !VCN.electricity,
    gas: VCN.gas === null || VCN.gas === undefined ? customer.changeSupplyOwnership['changeSupplyOwnership-gas'] : !VCN.gas,
  }
  /*
  We do not take into account the P0 for the change of ownership.
const changeSupplyOwnership = {
  electricity: customer.data['changeSupplyOwnership-electricity'],
  gas: customer.data['changeSupplyOwnership-gas'],
}
*/

  const { locutionData } = order.locutionData || {}
  if (productsVariants) {
    let orderItem
    const supplyPoints = customer.supplyPoints
    const isDualTariff =
      supplyPoints?.some((supplyPoint) => supplyPoint?.energyType === ELECTRICITY || supplyPoint?.technicalInfoElectricity?.energyType === ELECTRICITY) &&
      supplyPoints?.some((supplyPoint) => supplyPoint?.energyType === GAS || supplyPoint?.technicalInfoGas?.energyType === GAS)
    if (isDualTariff) {
      productsVariants.forEach((product) => {
        const techInfo = supplyPoints.find((supplyPoint) => supplyPoint?.energyType === product?.energyType || 
        supplyPoint?.technicalInfoElectricity?.energyType === ELECTRICITY || 
        supplyPoint?.technicalInfoGas?.energyType === GAS)
        
        // Manejar ambos formatos de techInfo:
        // Formato 1: techInfo con supplyaddress y technicalInfoElectricity/Gas anidados
        // Formato 2: techInfo ya contiene toda la información técnica directamente
        const hasTechnicalInfoNested = !!(techInfo?.technicalInfoElectricity || techInfo?.technicalInfoGas || techInfo)
        const actualTechInfo = hasTechnicalInfoNested 
          ? (techInfo?.technicalInfoElectricity || techInfo?.technicalInfoGas)
          : techInfo
        
        // Extraer campos del formato correspondiente
        const {
          cups,
          accessTariff, // eslint-disable-line no-unused-vars
          postalCode,
          provinceName, // eslint-disable-line no-unused-vars
          municipalityName, // eslint-disable-line no-unused-vars
          supplyAddress = hasTechnicalInfoNested ? techInfo?.supplyaddress : actualTechInfo?.supplyAddress, // eslint-disable-line no-unused-vars
          addressLine, // eslint-disable-line no-unused-vars
          consumption, // Objeto anidado con consumption12Months, consumptionLastYear, etc.
          capacity, // Objeto anidado con capacityP1-P6, maxCapacity
          changeCapacity, // eslint-disable-line no-unused-vars
          newSupply,
          activationDate,
          selfConsumptionCupsType, // eslint-disable-line no-unused-vars
          selfConsumptionType,
          selfConsumptionCollective, // eslint-disable-line no-unused-vars
          selfConsumptionPowerInstalled, // eslint-disable-line no-unused-vars
          selfConsumptionRegister, // eslint-disable-line no-unused-vars
          selfConsumptionSubsectionType,
          codResult, // eslint-disable-line no-unused-vars
          descResult, // eslint-disable-line no-unused-vars
        } = actualTechInfo || {}
        let { contractType } = actualTechInfo || {}
        const energyProp = product.energyType === GAS ? 'technicalInfoGas' : 'technicalInfoElectricity'
        const capacityProps = {}

        const newSupplyInfo = newSupply
          ? product.energyType === ELECTRICITY
            ? mapNewSupplyElectricityTechInfo(techInfo)
            : mapNewSupplyGasTechInfo(techInfo)
          : {}
        const selectedSelfConsumption =
          selfconsumptionTypes.length &&
          (selfconsumptionTypes.find((item) => item.code === selfConsumptionType) ||
            selfconsumptionTypes.find((item) => item.code === WITOUT_SELFCONSUMPTION))
        const selfConsumptionSubsectionId = selectedSelfConsumption?.selfConsumptionSubsectionType?.find(
          (subsection) => subsection.code === (selfConsumptionSubsectionType || DEFAULT_TYPE_SUBSECTION[selfConsumptionType])
        )?.id

        for (let key in techInfo) {
          if (key.indexOf('capacity') !== -1) {
            capacityProps[key] = typeof techInfo[key] === 'string' ? parseFloat(techInfo[key].replace(',', '.')) : techInfo[key]
          }
        }
        const draftPricingCalculation = getFlatDraftPrice(product.energyType.toUpperCase(), flatRateFromDraft)
        const technicalInfoIdToSend = techInfo?.technicalInfoId
        const technicalInfoEnergy = techInfo?.modified ? techInfo : techInfo?.technicalInfoElectricity || techInfo?.technicalInfoGas
        const technicalInfoToSend = technicalInfoEnergy ? sendNullValues(normalizeTechnicalInfo(technicalInfoEnergy)) : ''
        orderItem = {
          byCups: byCups ? (product.energyType === ELECTRICITY ? byCups.electricity : byCups.gas) : null,
          productVariant: `${PRODUCT_VARIANTS_IRI}/${product.id}`,
          ...(technicalInfoIdToSend) && {
            [energyProp]: `/middleware/technical_info_${product.energyType.toLowerCase()}/${technicalInfoIdToSend}`
          },
          ...(technicalInfoToSend && {
                  [energyProp]:{
                    postalCode,
                    provinceName,
                    municipalityName,
                    addressLine,
                    ...technicalInfoToSend,
                    numberOfDevicesTransformed: technicalInfoToSend?.numberOfDevicesTransformed === '' ? null : technicalInfoToSend?.numberOfDevicesTransformed,
                    thermalInstallationDate: technicalInfoToSend?.thermalInstallationDate === '' ? null : technicalInfoToSend?.thermalInstallationDate,
                    ...newSupplyInfo,
                    id: technicalInfoIdToSend ? `/middleware/technical_info_${product.energyType.toLowerCase()}/${technicalInfoIdToSend}` : null,
                    ...(SELFCONSUMPTION_DISABLED
                    ? {
                        selfConsumptionType: `${SELFCONSUMPTION_CUPS_TYPE_IRI}/${
                          selectedSelfConsumption?.id || WITOUT_SELFCONSUMPTION_ID
                        }`,
                      }
                    : {
                        selfConsumptionCupsType,
                        selfConsumptionType: `${SELFCONSUMPTION_CUPS_TYPE_IRI}/${
                          selectedSelfConsumption?.id || WITOUT_SELFCONSUMPTION_ID
                        }`,
                        selfConsumptionPowerInstalled: selfConsumptionPowerInstalled
                          ? parseFloat(selfConsumptionPowerInstalled.replace(',', '.')) * 1000
                          : 0,
                        selfConsumptionRegister:
                          selfConsumptionRegister === true || selfConsumptionRegister === COLLECTIVE ? COLLECTIVE : INDIVIDUAL,
                        ...(selfConsumptionSubsectionId && {
                          selfConsumptionSubsectionType: `${SELFCONSUMPTION_CUPS_SUBSECTION_TYPE_IRI}/${selfConsumptionSubsectionId}`,
                        }),
                        selfConsumptionCollective:
                          selfConsumptionCollective === true || selfConsumptionCollective === COLLECTIVE
                            ? COLLECTIVE
                            : INDIVIDUAL,
                      }),
                    
                  } 
                }),
          changeSupplyOwnership:
            !!changeSupplyOwnership[product.energyType.toLowerCase()] ||
            actualTechInfo?.contractType === 'CCT' ||
            changeSupplyOwnershipFromDraft(product.energyType.toLowerCase(), orderDraft) ||
            changeSupplyOwnershipFromDuplicateDraft(product.energyType.toLowerCase(), duplicateOrdeDraft),
          activationDate: !!newSupplyInfo?.activationDate
            ? new Date(newSupplyInfo.activationDate).toISOString()
            : activationDate || null,
          guidelineDate,
          newSupply,
          origin: customer?.supplyAddress?.origin || '',
          ...getProductAttributes(selectedProduct),
        }
        if (selectedProduct?.flatRate && (techInfo?.annualCost || draftPricingCalculation?.annualCostAmount)) {
          orderItem.pricingCalculation = {
            supplyCapacityP1Amount: techInfo.PowerP1 || draftPricingCalculation?.supplyCapacityP1Amount || 0,
            supplyCapacityP1Unit: 'kW',
            supplyCapacityP2Amount: techInfo.PowerP2 || draftPricingCalculation?.supplyCapacityP2Amount || 0,
            supplyCapacityP2Unit: 'kW',
            annualCostAmount: techInfo.annualCost || draftPricingCalculation?.annualCostAmount,
            annualCostUnit: '€',
            channel: `${CHANNEL_IRI}/${selectedChannel.channelId || selectedChannel.channel.id}`,
            supplyAnnualBaseConsumptionAmount:
              techInfo.consumptionThreshold || draftPricingCalculation?.supplyAnnualBaseConsumptionAmount,
            supplyAnnualBaseConsumptionUnit: 'kWh',
            cups,
            desiredCapacity: techInfo.desiredCapacity,
            energyType: techInfo.energyType,
            maxConsumptionAmount: techInfo.maxConsumptionThreshold || draftPricingCalculation?.maxConsumptionAmount,
            maxConsumptionUnit: 'kWh',
            monthlyCostAmount: techInfo.monthlyCost || draftPricingCalculation?.monthlyCostAmount,
            monthlyCostUnit: '€',
            postalCode,
            annualCostAmountReduced: techInfo.annualCostReduced || draftPricingCalculation?.annualCostAmountReduced,
            monthlyCostAmountReduced: techInfo.monthlyCostReduced || draftPricingCalculation?.monthlyCostAmountReduced,
          }
        }

        productOrderLines.push(orderItem)
      })

      const orderAdditionalInfo = getOrderAdditionalInfo({
        campaigns,
        orderId: order?.orders?.[0]?.id || order?.id || orderIdOnlineChannel,
        userId,
        channelOffer: selectedChannel.id,
      })

      productOrderLines = [
        {
          orderLines: [
            ...productOrderLines,
            ...getServicesOrderLines(toppings, productOrderLines[0]?.activationDate, guidelineDate, customer),
          ],
          energyUse: isPyme ? customer.data.energyUse : DOMESTIC,
          supplyAddress: prepareAddress(
            customer.supplyPoints?.[0]?.supplyAddress?.supplyAddress || 
            customer.supplyPoints?.[0]?.supplyAddress ||
            customer.supplyAddress
          ),
          ...(isPhoneChannel ? { ...locutionData } : {}),
          ...orderAdditionalInfo,
        },
      ]
    } else if (supplyPoints?.length) {
      supplyPoints?.forEach((supplyPoint, index) => {
        let orderAdditionalInfo = getOrderAdditionalInfo({
          cnae: supplyPoint?.cnae ?? null,
          campaigns,
          orderId:
            supplyPoints.length < 2
              ? order?.orders?.[0]?.id || order?.id || orderDraft.id || orderIdOnlineChannel
              : order?.orders?.find((order) => order.cups === supplyPoint.cups)?.id ||
                orderDraft?.[index]?.id ||
                orderIdOnlineChannel,
          userId,
          channelOffer: selectedChannel.id,
        })
        // 🆕 Extraer datos técnicos del nuevo formato anidado
        // Manejar ambos formatos: con technicalInfoElectricity/Gas o directamente en supplyPoint
        const technicalInfo = supplyPoint.technicalInfoElectricity || supplyPoint.technicalInfoGas || supplyPoint || {}
         
        // IMPORTANTE: Si technicalInfo está vacío, usar directamente supplyPoint (formato plano)
        let accessTariff = technicalInfo.accessTariff || supplyPoint.accessTariff
        
        // CRÍTICO: Para duplicate order draft, accessTariff puede no existir
        // Inferir accessTariff basado en las capacidades para NNSS
        if (!accessTariff && supplyPoint.contractType === 'NNSS' && supplyPoint.energyType === 'ELECTRICITY') {
          // Determinar tarifa basada en capacidades
          const hasP3toP6 = supplyPoint.capacityP3 > 0 || supplyPoint.capacityP4 > 0 || supplyPoint.capacityP5 > 0 || supplyPoint.capacityP6 > 0
          if (hasP3toP6) {
            accessTariff = '3.0TD' // Tarifa 3.0TD si tiene capacidades P3-P6
          } else {
            accessTariff = '2.0TD' // Tarifa 2.0TD si solo tiene P1-P2
          }
        }
        const selectedVariant = productsVariants.find(({ tariff }) => {
          return accessTariff === tariff.type
        })
        if (selectedVariant && (supplyPoint.supplyAddress || customer.supplyAddress)) {
          const fallback = customer?.supplyAddressPayload || null
          const {
            cups = supplyPoint.cups,
            postalCode = supplyPoint?.postalCode || technicalInfo?.postalCode || fallback?.postalCode,
            provinceName = supplyPoint?.provinceName || fallback?.provinceName,  
            municipalityName = supplyPoint?.municipalityName || fallback?.municipalityName,
            supplyAddress = supplyPoint?.supplyAddress,
            addressLine = supplyPoint?.addressLine || supplyPoint?.supplyAddress?.niceAddress,
            consumption12Months = technicalInfo.consumption12Months || supplyPoint.consumption12Months,
            changeCapacity = technicalInfo.changeCapacity || supplyPoint.changeCapacity,
            newSupply = technicalInfo.newSupply || supplyPoint.newSupply,
            activationDate = technicalInfo.activationDate || supplyPoint.activationDate,
            energyType = technicalInfo.energyType || supplyPoint.energyType,
            selfConsumptionCupsType = technicalInfo.selfConsumptionCupsType || supplyPoint.selfConsumptionCupsType,
            selfConsumptionType = technicalInfo.selfConsumptionType || supplyPoint.selfConsumptionType,
            selfConsumptionCollective = technicalInfo.selfConsumptionCollective || supplyPoint.selfConsumptionCollective,
            selfConsumptionPowerInstalled = technicalInfo.selfConsumptionPowerInstalled || supplyPoint.selfConsumptionPowerInstalled,
            selfConsumptionRegister = technicalInfo.selfConsumptionRegister || supplyPoint.selfConsumptionRegister,
            selfConsumptionSubsectionType = technicalInfo.selfConsumptionSubsectionType || supplyPoint.selfConsumptionSubsectionType,
            codResult = technicalInfo.codResult || supplyPoint.codResult,
            descResult = technicalInfo.descResult || supplyPoint.descResult,
          } = supplyPoint

          let energyProp = 'technicalInfoElectricity'
          if (energyType === selectedProduct.energyType) {
            if (selectedProduct.energyType === GAS) {
              energyProp = 'technicalInfoGas'
            }
          } else {
            energyProp = `technicalInfo${capitalize(energyType)}`
          }
          const capacityProps = {}

          const newSupplyInfo = newSupply
            ? selectedProduct.energyType === ELECTRICITY
              ? mapNewSupplyElectricityTechInfo(supplyPoint)
              : mapNewSupplyGasTechInfo(supplyPoint)
            : {}
          const selectedSelfConsumption =
            selfconsumptionTypes.length &&
            (selfconsumptionTypes.find((item) => item.code === selfConsumptionType) ||
              selfconsumptionTypes.find((item) => item.code === WITOUT_SELFCONSUMPTION))
          const selfConsumptionSubsectionId = selectedSelfConsumption?.selfConsumptionSubsectionType?.find((subsection) => {
            return subsection.code === (selfConsumptionSubsectionType || DEFAULT_TYPE_SUBSECTION[selfConsumptionType])
          })?.id

          for (let key in supplyPoint) {
            if (key.indexOf('capacity') !== -1) {
              capacityProps[key] =
                typeof supplyPoint[key] === 'string' ? parseFloat(supplyPoint[key].replace(',', '.')) : supplyPoint[key]
            }
          }

          const draftPricingCalculation = getFlatDraftPrice(energyType.toUpperCase(), flatRateFromDraft)
          const technicalInfoIdToSend = supplyPoint?.technicalInfoId || technicalInfo?.id
          const technicalInfoEnergy = supplyPoint?.modified ? supplyPoint : supplyPoint?.technicalInfoElectricity || supplyPoint?.technicalInfoGas
          const technicalInfoToSend = technicalInfoEnergy ? sendNullValues(normalizeTechnicalInfo(technicalInfoEnergy)) : ''

          orderItem = {
            orderLines: [
              {
                byCups: byCups ? (selectedProduct.energyType === GAS ? byCups.gas : byCups.electricity) : null,
                productVariant: `${PRODUCT_VARIANTS_IRI}/${selectedVariant.id}`,
                ...(technicalInfoIdToSend && {
                  [energyProp]: `/middleware/technical_info_${energyType.toLowerCase()}/${technicalInfoIdToSend}`
                }),
                ...(technicalInfoToSend && {
                  [energyProp]:{
                    postalCode,
                    provinceName,
                    municipalityName,
                    addressLine,
                    ...technicalInfoToSend,
                    numberOfDevicesTransformed: technicalInfoToSend?.numberOfDevicesTransformed === '' ? null : technicalInfoToSend?.numberOfDevicesTransformed,
                    thermalInstallationDate: technicalInfoToSend?.thermalInstallationDate === '' ? null : technicalInfoToSend?.thermalInstallationDate,
                    ...newSupplyInfo,
                    id: technicalInfoIdToSend ? `/middleware/technical_info_${energyType.toLowerCase()}/${technicalInfoIdToSend}` : null,
                    ...(SELFCONSUMPTION_DISABLED
                    ? {
                        selfConsumptionType: `${SELFCONSUMPTION_CUPS_TYPE_IRI}/${
                          selectedSelfConsumption?.id || WITOUT_SELFCONSUMPTION_ID
                        }`,
                      }
                    : {
                        selfConsumptionCupsType,
                        selfConsumptionType: `${SELFCONSUMPTION_CUPS_TYPE_IRI}/${
                          selectedSelfConsumption?.id || WITOUT_SELFCONSUMPTION_ID
                        }`,
                        selfConsumptionPowerInstalled: selfConsumptionPowerInstalled
                          ? parseFloat(selfConsumptionPowerInstalled.replace(',', '.')) * 1000
                          : 0,
                        selfConsumptionRegister:
                          selfConsumptionRegister === true || selfConsumptionRegister === COLLECTIVE ? COLLECTIVE : INDIVIDUAL,
                        ...(selfConsumptionSubsectionId && {
                          selfConsumptionSubsectionType: `${SELFCONSUMPTION_CUPS_SUBSECTION_TYPE_IRI}/${selfConsumptionSubsectionId}`,
                        }),
                        selfConsumptionCollective:
                          selfConsumptionCollective === true || selfConsumptionCollective === COLLECTIVE
                            ? COLLECTIVE
                            : INDIVIDUAL,
                      }),
                    
                  } 
                }),
                origin: customer?.supplyAddress?.origin || '',
                changeSupplyOwnership:
                  !!changeSupplyOwnership[selectedProduct.energyType.toLowerCase()] ||
                  supplyPoint?.contractType === 'CCT' ||
                  changeSupplyOwnershipFromDraft(selectedProduct.energyType.toLowerCase(), orderDraft) ||
                  changeSupplyOwnershipFromDuplicateDraft(selectedProduct.energyType.toLowerCase(), duplicateOrdeDraft),
                activationDate: !!newSupplyInfo?.activationDate
                  ? new Date(newSupplyInfo.activationDate).toISOString()
                  : activationDate || null,
                guidelineDate,
                newSupply,
                ...getProductAttributes(selectedProduct, customer),
                ...(selectedProduct?.flatRate &&
                  (supplyPoint?.annualCost || draftPricingCalculation) && {
                    pricingCalculation: {
                      supplyCapacityP1Amount: supplyPoint.PowerP1 || draftPricingCalculation?.supplyCapacityP1Amount || 0,
                      supplyCapacityP1Unit: 'kW',
                      supplyCapacityP2Amount: supplyPoint.PowerP2 || draftPricingCalculation?.supplyCapacityP2Amount || 0,
                      supplyCapacityP2Unit: 'kW',
                      annualCostAmount: supplyPoint.annualCost || draftPricingCalculation?.annualCostAmount,
                      annualCostUnit: '€',
                      channel: `${CHANNEL_IRI}/${selectedChannel.channelId || selectedChannel.channel.id}`,
                      supplyAnnualBaseConsumptionAmount:
                        supplyPoint.consumptionThreshold || draftPricingCalculation?.supplyAnnualBaseConsumptionAmount,
                      supplyAnnualBaseConsumptionUnit: 'kWh',
                      cups,
                      desiredCapacity: supplyPoint.desiredCapacity,
                      energyType: supplyPoint.energyType,
                      maxConsumptionAmount: supplyPoint.maxConsumptionThreshold || draftPricingCalculation?.maxConsumptionAmount,
                      maxConsumptionUnit: 'kWh',
                      monthlyCostAmount: supplyPoint.monthlyCost || draftPricingCalculation?.monthlyCostAmount,
                      monthlyCostUnit: '€',
                      postalCode,
                      monthlyCostAmountReduced:
                        supplyPoint.monthlyCostReduced || draftPricingCalculation?.monthlyCostAmountReduced,
                      monthlyCostUnitReduced: '€',
                      annualCostAmountReduced: supplyPoint.annualCostReduced || draftPricingCalculation?.annualCostAmountReduced,
                    },
                  }),
              },
              ...getServicesOrderLines(toppings, activationDate, guidelineDate, customer),
            ],
            energyUse: isPyme ? customer.data.energyUse : DOMESTIC,
            supplyAddress: prepareAddress(supplyPoint.supplyAddress || customer.supplyAddress),
            ...(isPhoneChannel ? { ...locutionData } : {}),
            ...orderAdditionalInfo,
          }
          // TODO put pricingCalculation inside orderLines
          // if (selectedProduct?.flatRate && supplyPoint?.annualCost) {
          //   orderItem.pricingCalculation = {
          //     supplyCapacityP1Amount: supplyPoint.PowerP1,
          //     supplyCapacityP1Unit: 'kW',
          //     supplyCapacityP2Amount: supplyPoint.PowerP2,
          //     supplyCapacityP2Unit: 'kW',
          //     annualCostAmount: supplyPoint.annualCost,
          //     annualCostUnit: '€',
          //     channel: `${CHANNEL_IRI}/${selectedChannel.channelId || selectedChannel.channel.id}`,
          //     supplyAnnualBaseConsumptionAmount: supplyPoint.consumptionThreshold,
          //     supplyAnnualBaseConsumptionUnit: 'kWh',
          //     cups,
          //     desiredCapacity: supplyPoint.desiredCapacity,
          //     energyType: supplyPoint.energyType,
          //     maxConsumptionAmount: supplyPoint.maxConsumptionThreshold,
          //     maxConsumptionUnit: 'kWh',
          //     monthlyCostAmount: supplyPoint.monthlyCost,
          //     monthlyCostUnit: '€',
          //     postalCode,
          //   }
          // }

          productOrderLines.push(orderItem)
        }
      })
    } else {
      const orderAdditionalInfo = getOrderAdditionalInfo({
        campaigns,
        orderId: order?.orders?.[0]?.id || order?.id || orderIdOnlineChannel,
        userId,
        channelOffer: selectedChannel.id,
      })
      productOrderLines = [
        {
          orderLines: [...getServicesOrderLines(toppings, null, guidelineDate, customer)],
          energyUse: isPyme ? customer.data.energyUse : DOMESTIC,
          supplyAddress: prepareAddress(customer.supplyAddress || customer.billingAddress),
          ...(isPhoneChannel ? { ...locutionData } : {}),
          ...orderAdditionalInfo,
        },
      ]
    }
  } else {
    const orderAdditionalInfo = getOrderAdditionalInfo({
      campaigns,
      orderId: order?.orders?.[0]?.id || order?.id || orderIdOnlineChannel,
      userId,
      channelOffer: selectedChannel.id,
    })

    let supplyAddressOrder
    if (!customer.billingAddress && !customer.supplyAddress && order.supplyAddress) {
      supplyAddressOrder = order.supplyAddress
      supplyAddressOrder.id = '/middleware/addresses/' + order.supplyAddress.id
    }

    return [
      {
        orderLines: [...getServicesOrderLines(toppings, null, guidelineDate, customer)],
        energyUse: isPyme ? customer.data.energyUse : DOMESTIC,
        supplyAddress: prepareAddress(customer.supplyAddress || supplyAddressOrder || customer.billingAddress),
        ...(isPhoneChannel ? { ...locutionData } : {}),
        ...orderAdditionalInfo,
      },
    ]
  }
  return productOrderLines
}

const getProductVariantDual = (isDualTariff, productSelected) => {
  if (!isDualTariff) return null
  const productVariantDual = []
  if (productSelected.subProducts && productSelected.subProducts.length) {
    productSelected.subProducts.forEach((product) => {
      if (product.variants) {
        productVariantDual.concat(product.variants)
      }
    })
  }
  return productVariantDual
}

/**
 * Adds null values to technical info object for electricity
 * @param {Object} technicalInfo - The technical info object to modify
 * @returns {Object} - The modified technical info object with null values added
 */
const sendNullValues = (technicalInfo) => {
  if (!technicalInfo || typeof technicalInfo !== 'object') {
    return technicalInfo
  }

  // Define the null values to add
  const nullValues = {
    maxPowerBIE: null,
    validationClientNode: null,
    inForce: null,
    existApplicationOnCourse: null,
    typeApplicationInCourse: null,
    reasonNotContactable: null,
    reasonRejectionPo: null,
    distributorResponse: false,
    distributor: null,
    datosCau: null,
    pressureLevel: null,
  }

  return {
    ...technicalInfo,
    ...nullValues,
  }
}

/**
 * Normaliza los datos técnicos para enviar al backend
 * Convierte campos según el tipo esperado por la API
 */
const normalizeTechnicalInfo = (technicalInfo) => {
  if (!technicalInfo || typeof technicalInfo !== 'object') return technicalInfo
  
  const normalized = { ...technicalInfo }
  
  // Campos que deben ser string
  const stringFields = ['consumption12Months']
  
  // Campos que deben ser float (números)
  const floatFields = ['maxCapacity', 'capacityP1', 'capacityP2', 'capacityP3', 'capacityP4', 'capacityP5', 'capacityP6']
  
  stringFields.forEach(field => {
    if (normalized[field] !== undefined && normalized[field] !== null) {
      normalized[field] = String(normalized[field])
    }
  })
  
  floatFields.forEach(field => {
    // Si el campo no existe, está undefined, null o es string vacío, asignar 0
    if (normalized[field] === undefined || normalized[field] === null || normalized[field] === '') {
      normalized[field] = 0
    } else {
      // Convertir a número
      const value = typeof normalized[field] === 'string' 
        ? parseFloat(normalized[field].replace(',', '.'))
        : Number(normalized[field])
      // Si no es un número válido, asignar 0
      normalized[field] = isNaN(value) ? 0 : value
    }
  })
  
  return normalized
}

export const getServicesOrderLines = (toppings, activationDate, guidelineDate, customer) => {
  const servicesOrderLines = []
  const services = toppings.selected
  const selectedToppingsIds = services ? Object.keys(services) : []

  if (selectedToppingsIds.length) {
    selectedToppingsIds.forEach((toppingId) => {
      servicesOrderLines.push({
        service: `${SERVICE_IRI}/${toppingId}`,
        portability: services[toppingId].portability || false,
        tenureServiceId: services[toppingId].tenureServiceId || null,
        activationDate: activationDate || null,
        guidelineDate,
        ...getServicesAttributes(services[toppingId]),
        origin: customer?.supplyAddress?.origin || '',
      })
    })
  }
  return servicesOrderLines
}
export const toCammelCase = (str) => {
  return str.replace(/-([a-z])/g, function (match, group1) {
    return group1.toUpperCase()
  })
}

export const getProductAttributes = (product, customer) => {
  const rawAttributes = (
    product.subProducts ? product.subProducts.find((subProduct) => subProduct.energyType === ELECTRICITY) : product
  ).attributes

  const formattedAttributes =
    rawAttributes &&
    Object.keys(rawAttributes).reduce((acc, key) => {
      if (key === 'product-online' && customer?.company?.code === COMPANY_CODES.newco) {
        acc[toCammelCase(key.replace('product-', ''))] = customer.onlineInvoice
      } else {
        acc[toCammelCase(key.replace('product-', ''))] = rawAttributes[key]
      }
      return acc
    }, {})
  return formattedAttributes
}

export const getServicesAttributes = (service) => {
  const rawAttributes = service.serviceAttributes
  const acc = {}
  rawAttributes.forEach((item) => {
    acc[toCammelCase(item.attribute.name.replace('service-', ''))] = item.enabled
  })
  return acc
}

export const getOrderAdditionalInfo = ({ campaigns, orderId, userId, channelOffer }) => {
  const appliedCampaignId = campaigns.applied?.id
  return {
    ...(orderId && { id: `${ORDER_IRI}/${orderId}` }),
    priceReservationDate: new Date().toISOString(),
    user: `${USER_IRI}/${userId}`,
    channelOffer: `${CHANNEL_OFFERS_IRI}/${channelOffer}`,
    campaign: appliedCampaignId ? `${CAMPAIGN_IRI}/${appliedCampaignId}` : null,
  }
}

export const mapLeadData = ({ customer, isOnlineChannel, tenure }) => {
  let data = {}
  // Customer data
  const {
    email,
    phone,
    name: firstName,
    lastName,
    secondLastName,
    nationality,
    idDocumentType: documentType,
    idDocumentNumber: documentNumber,
    language: preferredLanguage,
    complexProfilePolicy: checkGDPR1,
    publicityPolicy: checkGDPR2,
    thirdPartyPolicy: checkGDPR3,
    retargeting,
    energyUse,
    cnae,
    contactName,
    contactLastName,
    contactSecondLastName,
    contactDegree,
    contactDocumentNumber,
    contactTelephone,
    contactMobilePhone,
    contactFax,
    contactEmail,
  } = customer.data
  const {
    birthdayDate,
    onBehalfContactId,
    referralCode,
    productReferralCode,
    buyapowaCode,
    selectedTenure,
    company: selectedCompany,
  } = customer

  let customerData = {
    email: email?.toLowerCase() || '',
    phone,
    firstName,
    lastName: lastName || '',
    secondLastName: secondLastName || '',
    documentType,
    nationality,
    documentNumber: documentNumber?.toUpperCase(),
    preferredLanguage,
    cnae: cnae && energyUse === ENERGY_USES.commercial ? cnae : null,
    referralCode,
    productReferralCode,
    buyapowaCode,
    contact: contactName
      ? {
          id: onBehalfContactId,
          name: contactName,
          lastName: contactLastName,
          secondLastName: contactSecondLastName,
          degree: contactDegree,
          documentNumber: contactDocumentNumber,
          phone: contactTelephone,
          mobilePhone: contactMobilePhone,
          fax: contactFax,
          email: contactEmail,
        }
      : null,
  }

  // Add GDPR Checks to customerData if is Online Channel
  if (isOnlineChannel) {
    customerData = {
      ...customerData,
      ...{
        checkGDPR1,
        checkGDPR2,
        checkGDPR3,
        retargeting,
        socialBonus: false,
      },
    }
  }

  // Billing data
  const {
    accountHolder,
    accountHolderSurnames,
    accountHolderDocumentNumber,
    accountHolderDocumentType,
    accountHolderLastName,
    accountHolderSecondLastName,
    accountIban,
  } = customer.billingAccount || {}
  const {
    tenureAddressId,
    externalId,
    postalCode,
    provinceName,
    municipalityName,
    townName,
    streetType,
    streetName,
    number,
    portal,
    stair,
    floor,
    door,
    placeId,
    extraData,
    masterId,
    isNewAddress,
  } = customer.billingAddress || {}

  let { addressLine, electricityCups, gasCups, technicalInfoId, variants, products, services, ...supplyAddress } =
    customer?.normalizedAddress || {}
  const isPortabilityFromGnsToNewco =
    selectedTenure?.company === COMPANY_CODES.gns && selectedCompany.code === COMPANY_CODES.newco

  supplyAddress = customer?.normalizedAddress
    ? {
        tenureAddressId: customer.selectedTenure?.addressId || supplyAddress.addressId || '',
        externalId: customer.selectedTenure?.addressId || supplyAddress?.externalId,
        postalCode: customer.selectedTenure?.postalCode || supplyAddress?.postalCode || '',
        provinceName: customer.selectedTenure?.provinceName || supplyAddress?.provinceName || '',
        municipalityName: customer.selectedTenure?.municipalityName || supplyAddress?.municipalityName || '',
        townName: customer.selectedTenure?.addressTown || supplyAddress?.townName || '',
        streetType: supplyAddress?.streetType?.toUpperCase() || '',
        streetName: customer.selectedTenure?.addressStreet || supplyAddress?.streetName || '',
        number: customer.selectedTenure?.addressNumber || supplyAddress?.number?.toString() || '',
        portal: customer.selectedTenure?.addressPortal || supplyAddress?.portal || '',
        stair: customer.selectedTenure?.addressStaircase || supplyAddress?.stair || '',
        floor: customer.selectedTenure?.addressFloor || supplyAddress?.floor || '',
        door: customer.selectedTenure?.addressDoor || supplyAddress?.door || '',
        placeId: supplyAddress?.placeId || '',
        masterId: supplyAddress?.verticalId || '',
        extraData: supplyAddress?.extraData || '',
        isNewAddress: supplyAddress?.isNewAddress || false,
      }
    : customer.supplyAddress || undefined

  // TODO IMPROVE MAPPING
  if (isPortabilityFromGnsToNewco) {
    supplyAddress.tenureAddressId = ''
  } else if (supplyAddress && tenure?.addressId) {
    supplyAddress.tenureAddressId = tenure.addressId
  }
  const billingAddress = customer?.billingAddress
    ? {
        tenureAddressId: isPortabilityFromGnsToNewco ? '' : tenureAddressId || '',
        externalId,
        postalCode,
        provinceName,
        municipalityName,
        townName,
        streetType,
        streetName,
        number,
        portal,
        stair,
        floor,
        door,
        placeId,
        extraData,
        masterId,
        isNewAddress,
      }
    : supplyAddress || undefined
  const billingData = {
    accountHolder,
    accountHolderSurnames,
    accountHolderDocumentNumber,
    accountHolderDocumentType,
    accountHolderLastName,
    accountHolderSecondLastName,
    accountIban: accountIban ? accountIban.replace(/\s/g, '') : undefined,
    billingAddress,
    birthdayDate,
  }

  // Online invoice
  const onlineInvoice = isOnlineChannel || (customer.onlineInvoice && !!email)

  data = {
    customerData,
    billingData,
    onlineInvoice: !!onlineInvoice,
  }

  return data
}

export const mapNewSupplyElectricityTechInfo = ({
  newSupply,
  activationDate,
  consumption12Months,
  name,
  lastName,
  secondLastName,
  degree,
  documentNumber,
  mobilePhone,
  phone,
  fax,
  email,
  ...technicalInfo
}) => {
  const tempNewSupplyObj = {
    ...technicalInfo,
    consumption12Months: formatNumber(consumption12Months) ? formatNumber(consumption12Months).toString() : consumption12Months,
    activationDate: activationDate ? new Date(activationDate).toISOString() : null,
  }

  if (
    Object.hasOwn(tempNewSupplyObj, 'selfConsumptionSubsectionType') &&
    tempNewSupplyObj.selfConsumptionSubsectionType == null
  ) {
    delete tempNewSupplyObj.selfConsumptionSubsectionType
  }
  if (Object.hasOwn(tempNewSupplyObj, 'selfConsumptionType') && tempNewSupplyObj.selfConsumptionType == null) {
    delete tempNewSupplyObj.selfConsumptionType
  }
  return tempNewSupplyObj
}

export const mapNewSupplyGasTechInfo = ({
  newSupply,
  consumption12Months,
  numberOfDevicesTransformed,
  iriCertificateDate,
  thermalInstallationDate,
  activationDate,
  designCapacity,
  ...technicalInfo
}) => {
  // Parse numberOfDevicesTransformed safely - ensure it's always an integer or null
  const parsedDevices = parseInt(numberOfDevicesTransformed, 10)
  const safeNumberOfDevices = !isNaN(parsedDevices) && numberOfDevicesTransformed !== '' && numberOfDevicesTransformed != null 
    ? parsedDevices 
    : null

  const tempNewSupplyObj = {
    ...technicalInfo,
    designCapacity: formatNumber(designCapacity) || designCapacity,
    consumption12Months: formatNumber(consumption12Months) ? formatNumber(consumption12Months).toString() : consumption12Months,
    numberOfDevicesTransformed: safeNumberOfDevices,
    iriCertificateDate: iriCertificateDate ? new Date(iriCertificateDate).toISOString() : null,
    thermalInstallationDate: thermalInstallationDate ? new Date(thermalInstallationDate).toISOString() : null,
    activationDate: activationDate ? new Date(activationDate).toISOString() : null,
  }
  if (
    Object.hasOwn(tempNewSupplyObj, 'selfConsumptionSubsectionType') &&
    tempNewSupplyObj.selfConsumptionSubsectionType == null
  ) {
    delete tempNewSupplyObj.selfConsumptionSubsectionType
  }
  if (Object.hasOwn(tempNewSupplyObj, 'selfConsumptionType') && tempNewSupplyObj.selfConsumptionType == null) {
    delete tempNewSupplyObj.selfConsumptionType
  }
  return tempNewSupplyObj
}

const mapAddressData = (customer, supplyPoint) => {
  const isPortabilityFromGnsToNewco =
    customer.selectedTenure?.company === COMPANY_CODES.gns && customer.company.code === COMPANY_CODES.newco

  return {
    tenureAddressId: isPortabilityFromGnsToNewco
      ? ''
      : customer.selectedTenure?.addressId || supplyPoint?.supplyAddress?.addressId || customer.supplyAddress?.addressId || '',
    externalId:
      customer.selectedTenure?.externalId || supplyPoint?.supplyAddress?.externalId || customer.supplyAddress?.externalId,
    postalCode:
      customer.selectedTenure?.postalCode || supplyPoint?.supplyAddress?.postalCode || customer.supplyAddress?.postalCode || '',
    provinceName:
      customer.selectedTenure?.provinceName ||
      supplyPoint?.supplyAddress?.provinceName ||
      customer.supplyAddress?.provinceName ||
      '',
    municipalityName:
      customer.selectedTenure?.municipalityName ||
      supplyPoint?.supplyAddress?.municipalityName ||
      customer.supplyAddress?.municipalityName ||
      '',
    townName:
      customer.selectedTenure?.addressTown || supplyPoint?.supplyAddress?.addressTown || customer.supplyAddress?.townName || '',
    streetType: customer.supplyAddress?.streetType?.toUpperCase() || supplyPoint?.supplyAddress?.streetType?.toUpperCase() || '',
    streetName:
      customer.selectedTenure?.addressStreet ||
      supplyPoint?.supplyAddress?.streetName ||
      customer.supplyAddress?.streetName ||
      '',
    number:
      customer.selectedTenure?.addressNumber ||
      supplyPoint?.supplyAddress?.number ||
      customer.supplyAddress?.number?.toString() ||
      '',
    portal: customer.selectedTenure?.addressPortal || supplyPoint?.supplyAddress?.portal || customer.supplyAddress?.portal || '',
    stair: customer.selectedTenure?.addressStaircase || supplyPoint?.supplyAddress?.stair || customer.supplyAddress?.stair || '',
    floor: customer.selectedTenure?.addressFloor || supplyPoint?.supplyAddress?.floor || customer.supplyAddress?.floor || '',
    door: customer.selectedTenure?.addressDoor || supplyPoint?.supplyAddress?.door || customer.supplyAddress?.door || '',
    placeId: customer.selectedTenure?.placeId || supplyPoint?.supplyAddress?.placeId || customer.supplyAddress?.placeId || '',
    masterId:
      customer.selectedTenure?.verticalId || supplyPoint?.supplyAddress?.verticalId || customer.supplyAddress?.verticalId || '',
    isNewAddress: supplyPoint?.supplyAddress?.isNewAddress || customer.supplyAddress?.isNewAddress || false,
    extraData:
      customer.selectedTenure?.extraData || supplyPoint?.supplyAddress?.extraData || customer.supplyAddress?.extraData || '',
  }
}

const prepareAddress = (address,isBilling) => {
  
  // Si no hay dirección, devolver undefined
  if (!address) {
    return undefined
  }

  // PRIORIDAD 1: Si tiene ID o addressId (incluso si tiene otros campos), enviar SOLO el ID
  // Esto cubre el caso donde el objeto tiene todos los campos + el ID
  const addressId = address?.id || address?.addressId
  
  if (addressId) {
    
    // Comportamiento normal para casos posteriores o cuando isBilling es false
    // Si el ID ya tiene el prefijo, devolverlo tal cual
    const hasPrefix = addressId.startsWith('/middleware/addresses/')
    const result = hasPrefix ? addressId : `/middleware/addresses/${addressId}` 
    
    return result
  }

  // PRIORIDAD 2: Si NO tiene ID, es dirección manual (modal newSupplyAddress)
  // Enviar todos los campos para que el backend cree la dirección
  return {
    tenureAddressId: address.tenureAddressId || '',
    externalId: address.externalId || '',
    postalCode: address.postalCode || '',
    provinceName: address.provinceName || '',
    municipalityName: address.municipalityName || '',
    municipalityCode: address.municipalityCode || '',
    provinceCode: address.provinceCode || '',
    townName: address.townName || '',
    streetType: address.streetType?.toUpperCase() || '',
    streetName: address.streetName || '',
    number: address.number?.toString() || '',
    portal: address.portal || '',
    stair: address.stair || '',
    floor: address.floor || '',
    door: address.door || '',
    placeId: address.placeId || '',
    masterId: address.masterId || address.verticalId || '',
    extraData: address.extraData || '',
    isNewAddress: address.isNewAddress !== undefined ? address.isNewAddress : true,
  }
}

const capitalize = (s) => (s && s[0].toUpperCase() + s.toLowerCase().slice(1)) || ''

export const isEqualAddress = (addressA, addressB) => {
  return (
    addressA?.postalCode?.trim().toUpperCase() === addressB?.postalCode?.trim().toUpperCase() &&
    addressA?.provinceName?.trim().toUpperCase() === addressB?.provinceName?.trim().toUpperCase() &&
    addressA?.townName?.trim().toUpperCase() === addressB?.townName?.trim().toUpperCase() &&
    addressA?.municipalityName?.trim().toUpperCase() === addressB?.municipalityName?.trim().toUpperCase() &&
    addressA?.streetName?.trim().toUpperCase() === addressB?.streetName?.trim().toUpperCase() &&
    `${+addressA?.number}` === `${+addressB?.number}` &&
    addressA?.portal?.trim().toUpperCase() === addressB?.portal?.trim().toUpperCase() &&
    addressA?.stair?.trim().toUpperCase() === addressB?.stair?.trim().toUpperCase() &&
    (addressA?.floor?.trim().toUpperCase() === addressB?.floor?.trim().toUpperCase() ||
      `${+addressA?.floor?.trim()}` === `${+addressB?.floor}`) &&
    addressA?.door?.trim().toUpperCase() === addressB?.door?.trim().toUpperCase()
  )
}
